import { ConversationId } from "@redotech/effect-api-shared/ids/definitions";
import { Schema } from "effect";

const isConversationId = Schema.is(ConversationId);

export function isSupportV2ConversationId(
  conversationId: string | null | undefined,
): conversationId is ConversationId {
  return typeof conversationId === "string" && isConversationId(conversationId);
}
